import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    margin-bottom: 100px;
  }
`;

export const ChooseLevel = styled.section`
  display: flex;
  flex-direction: column;
`;
